<template>
  <v-layout row wrap justify-center>
    <pg-detail
      :title="title"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :deleteProcess="deleteDialog"
      :fab="profil.role == 'ADMIN'"
      @found="selected = [$event]"
      @add="openInputDialog('ADD')"
      @update="openInputDialog('UPDATE')"
      @delete="deleteDialog = true"
    >
      <template slot="detail-content" slot-scope="props">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">account_balance</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Nama Client</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.client
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">pin_drop</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Kab/Kota</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.kab_kota | noEmpty
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">today</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Tanggal Gabung</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.tgl_gabung | niceDate }}
                    <small>{{
                      props.detail.tgl_gabung | moment("from", "now")
                    }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">people</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Jumlah Karyawan</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.jml_karyawan }}
                    <small>Orang</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">trending_up</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Target per Tahun</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.target_per_tahun }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">assignment_turned_in</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total Training</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_training }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">local_offer</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Business Unit</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.laman }}
                    <small>{{ props.detail.laman_desc }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile
                v-ripple
                :to="{
                  name: 'ClientArea',
                  query: { id: props.detail.id_area }
                }"
              >
                <v-list-tile-action>
                  <v-icon color="secondary">map</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Area</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.area }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">flash_on</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Status</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-chip
                      v-if="parseInt(props.detail.active_client)"
                      color="green"
                      class="white--text"
                      label
                      >AKTIF</v-chip
                    >
                    <v-chip v-else color="red" class="white--text" label
                      >SUDAH PUTUS</v-chip
                    >
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
          </v-flex>
          <v-flex xs12 sm6>
            <v-expansion-panel class="elevation-1" focusable>
              <v-expansion-panel-content :value="true">
                <div slot="header">TRAINING TERKAIT</div>
                <v-subheader v-if="!props.detail.training.length" class="mb-3">
                  {{ title }} ini tidak memiliki keterkaitan data dengan
                  TRAINING.
                </v-subheader>
                <vue-perfect-scrollbar v-else style="max-height: 400px">
                  <v-list two-line>
                    <v-list-tile
                      v-for="(item, i) in props.detail.training"
                      :key="i"
                      style="border-bottom: 1px solid #eee"
                      v-ripple
                      :to="{
                        name: 'TrainingList',
                        query: { id: item.id_training }
                      }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.materi }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.waktu_mulai | moment("from", "now")
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </vue-perfect-scrollbar>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </template>
    </pg-detail>
    <template v-if="!$route.query.id">
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-2">
            <v-btn color="green" dark icon @click.stop="openInputDialog('ADD')">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              color="blue"
              :disabled="selected.length != 1"
              dark
              icon
              @click.stop="openInputDialog('UPDATE')"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              color="red"
              :disabled="selected.length == 0"
              dark
              icon
              @click.stop="deleteDialog = true"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <json-excel
              :data="selected"
              :export-fields="jsonFields"
              :name="`${$route.name}.xls`"
            >
              <v-btn color="indigo" :disabled="selected.length == 0" dark icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </json-excel>
            <v-btn
              :color="!filterOn ? 'grey' : 'orange'"
              :disabled="!sourceData.length && !filterOn"
              dark
              icon
              @click.stop="filterDialog = true"
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <v-btn
              color="purple"
              :disabled="selected.length < 2"
              dark
              icon
              @click.stop="mergeDialog = true"
            >
              <v-icon>call_merge</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pencarian"
              clearable
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-if="!$vuetify.breakpoint.xs"
            v-model="selected"
            :headers="headers"
            :items="sourceData"
            :search="search"
            :pagination.sync="pagination"
            :loading="!client_loaded"
            select-all
            item-key="id_client"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            class="elevation-1"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  >
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable ',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align ? `text-xs-${header.align}` : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <v-progress-linear
              slot="progress"
              color="primary"
              :height="3"
              indeterminate
            >
            </v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                :active="props.selected"
                class="nowrap"
                :class="{
                  'red lighten-4': !parseInt(props.item.active_client)
                }"
                @click="toggleExpand(props)"
              >
                <td style="width: 80px">
                  <v-checkbox
                    :input-value="props.selected"
                    @click.stop="props.selected = !props.selected"
                    primary
                    hide-details
                  >
                  </v-checkbox>
                </td>
                <td>
                  <v-chip
                    small
                    label
                    @click.stop="
                      $router.push({
                        name: $route.name,
                        query: { id: props.item.id_client }
                      })
                    "
                  >
                    {{ props.item.client }}
                  </v-chip>
                </td>
                <td>{{ props.item.area }}</td>
                <td>{{ props.item.kab_kota | noEmpty }}</td>
                <td class="text-xs-center">
                  {{ props.item.tgl_gabung | moment("DD MMM YYYY") }}
                </td>
                <td class="text-xs-center">{{ props.item.jml_karyawan }}</td>
                <td class="text-xs-center">
                  {{ props.item.target_per_tahun }}
                </td>
                <td class="text-xs-center">{{ props.item.total_training }}</td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props"
              v-if="$vuetify.breakpoint.xs"
            >
              <v-card
                flat
                :color="$vuetify.dark ? 'grey darken-1' : 'grey lighten-5'"
              >
                <table class="expanded">
                  <tr v-for="(header, i) in headers" :key="`rows-${i}`">
                    <td>{{ header.text }}</td>
                    <td v-if="header.value == 'tgl_gabung'">
                      {{ props.item.tgl_gabung | moment("DD MMM YYYY") }}
                    </td>
                    <td v-else>{{ props.item[header.value] | noEmpty }}</td>
                  </tr>
                </table>
              </v-card>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-table>

          <v-data-iterator
            v-else
            v-model="selected"
            :items="sourceData"
            :pagination.sync="pagination"
            :loading="!client_loaded"
            :search="search"
            select-all
            item-key="id_client"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12>
              <v-card
                :class="{
                  'red lighten-4': !parseInt(props.item.active_client)
                }"
              >
                <v-list-tile>
                  <v-list-tile-action>
                    <v-checkbox
                      :input-value="props.selected"
                      @click.stop="props.selected = !props.selected"
                      class="ma-0 pa-0"
                      hide-details
                      primary
                    >
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      props.item.client
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      props.item.area
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :to="{
                        name: $route.name,
                        query: { id: props.item.id_client }
                      }"
                      fab
                      flat
                      small
                      color="primary"
                    >
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-slide-y-transition>
                  <!-- <div v-show="props.selected"> -->
                  <v-list
                    dense
                    :class="props.selected ? 'secondary white--text' : ''"
                  >
                    <v-list-tile v-for="(header, i) in simpleHeaders" :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="header.value == 'tgl_gabung'"
                          >{{
                            props.item.tgl_gabung | moment("DD MMM YYYY")
                          }}</v-list-tile-sub-title
                        >
                        <v-list-tile-sub-title v-else>{{
                          props.item[header.value] | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!-- </div> -->
                </v-slide-y-transition>
              </v-card>
            </v-flex>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-iterator>
        </v-card>
      </v-flex>

      <pg-form-filter
        :dialog="filterDialog"
        :filterOn="filterOn"
        :filter="filter"
        :source="sourceData"
        :sourceOriginal="sourceOriginal"
        :title="title"
        @close="filterDialog = false"
        @toggle="
          filterOn = !filterOn;
          filterDialog = false;
        "
        @filtered="filterSource = $event"
      >
        <template slot="filter-content" slot-scope="props">
          <v-autocomplete
            append-icon="account_balance"
            attach
            hide-details
            item-text="client"
            item-value="id_client"
            multiple
            :items="clientByLaman"
            v-model="props.filter.id_client"
            label="Nama Client"
          >
            <template slot="selection" slot-scope="data">
              {{ `${data.item.client} (${data.item.area})` }},
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content
                :class="{ 'red--text': !parseInt(data.item.active_client) }"
              >
                <v-list-tile-title>{{ data.item.client }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.area
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            append-icon="pin_drop"
            attach
            hide-details
            multiple
            :items="props.filter.field.kab_kota"
            v-model="props.filter.kab_kota"
            label="Kab/Kota"
          >
          </v-autocomplete>
          <v-autocomplete
            append-icon="map"
            attach
            hide-details
            multiple
            item-text="area"
            item-value="id_area"
            :items="areaByLaman"
            v-model="props.filter.id_area"
            label="Area"
          >
          </v-autocomplete>
          <v-autocomplete
            append-icon="flash_on"
            attach
            hide-details
            item-text="val"
            item-value="key"
            multiple
            :items="props.filter.field.active_client"
            v-model="props.filter.active_client"
            label="Status"
          >
          </v-autocomplete>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-dialog
                  v-model="filterDialogTglGabungAwal"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <v-text-field
                    slot="activator"
                    append-icon="today"
                    hide-details
                    type="text"
                    readonly
                    v-model="props.filter.tgl_gabung[0]"
                    label="Tanggal Gabung"
                  ></v-text-field>
                  <v-date-picker
                    v-model="props.filter.tgl_gabung[0]"
                    @input="filterDialogTglGabungAwal = false"
                    :min="
                      $moment(props.filter.field.tgl_gabung[0]).format(
                        'YYYY-MM-DD'
                      )
                    "
                    :max="
                      $moment(props.filter.tgl_gabung[1]).format('YYYY-MM-DD')
                    "
                    locale="id-id"
                  >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6>
                <v-dialog
                  v-model="filterDialogTglGabungAkhir"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <v-text-field
                    slot="activator"
                    append-icon="today"
                    hide-details
                    type="text"
                    readonly
                    v-model="props.filter.tgl_gabung[1]"
                  ></v-text-field>
                  <v-date-picker
                    v-model="props.filter.tgl_gabung[1]"
                    @input="filterDialogTglGabungAkhir = false"
                    :min="
                      $moment(props.filter.tgl_gabung[0]).format('YYYY-MM-DD')
                    "
                    :max="
                      $moment(props.filter.field.tgl_gabung[1]).format(
                        'YYYY-MM-DD'
                      )
                    "
                    locale="id-id"
                  >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-container>
          <v-range-slider
            v-model="props.filter.jml_karyawan"
            label="Jumlah Karyawan"
            append-icon="people"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.jml_karyawan[0]"
            :max="props.filter.field.jml_karyawan[1]"
            thumb-label="always"
          >
          </v-range-slider>
          <v-range-slider
            v-model="props.filter.target_per_tahun"
            label="Target per Tahun"
            append-icon="trending_up"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.target_per_tahun[0]"
            :max="props.filter.field.target_per_tahun[1]"
            thumb-label="always"
          >
          </v-range-slider>
          <v-range-slider
            v-model="props.filter.total_training"
            label="Total Training"
            append-icon="assignment_turned_in"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_training[0]"
            :max="props.filter.field.total_training[1]"
            thumb-label="always"
          >
          </v-range-slider>
        </template>
      </pg-form-filter>

      <pg-form-merge
        :dialog="mergeDialog"
        :selected="selected"
        :title="title"
        :primary_key="primary_key"
        @cancel="mergeDialog = false"
        @merged="onMerged"
        action="client/MERGE_CLIENT"
      >
        <template slot="item-detail" slot-scope="props">
          {{ props.item.client }} - {{ props.item.area }}
        </template>
      </pg-form-merge>
    </template>

    <pg-form-delete
      :dialog="deleteDialog"
      :selected="selected"
      :title="title"
      :primary_key="primary_key"
      @cancel="deleteDialog = false"
      @deleted="onDeleted"
      action="client/DELETE_CLIENT"
    >
      <template slot="item-detail" slot-scope="props">
        {{ props.item.client }} - {{ props.item.area }}
      </template>
    </pg-form-delete>

    <client-input
      :dialog="inputDialog"
      :data="selected[0]"
      :title="title"
      :action="inputAction"
      :primary_key="primary_key"
      :primary_field="primary_field"
      @cancel="inputDialog = false"
      @submitted="onSubmitted"
    >
    </client-input>
  </v-layout>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import JsonExcel from "vue-json-excel";
import PgDetail from "@/components/private/PgDetail";
import PgFormDelete from "@/components/private/PgFormDelete";
import PgFormMerge from "@/components/private/PgFormMerge";
import PgFormFilter from "@/components/private/PgFormFilter";
import ClientInput from "@/components/pages/input/ClientInput";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState, mapGetters } from "vuex";

const defaultFilter = {
  id_client: [],
  id_area: [],
  jml_karyawan: [0, 100],
  target_per_tahun: [0, 100],
  total_training: [0, 100],
  tgl_gabung: ["", ""],
  kab_kota: [],
  active_client: [],
  field: {
    kab_kota: [],
    jml_karyawan: [0, 100],
    target_per_tahun: [0, 100],
    total_training: [0, 100],
    tgl_gabung: ["", ""],
    active_client: [{ key: "1", val: "AKTIF" }, { key: "0", val: "PUTUS" }]
  },
  format: {
    id_client: c.FORMAT.options,
    id_area: c.FORMAT.options,
    jml_karyawan: c.FORMAT.number,
    target_per_tahun: c.FORMAT.number,
    total_training: c.FORMAT.number,
    tgl_gabung: c.FORMAT.date,
    kab_kota: c.FORMAT.text_options,
    active_client: c.FORMAT.text_options
  }
};

export default {
  name: "client",
  components: {
    JsonExcel,
    VuePerfectScrollbar,
    PgDetail,
    PgFormDelete,
    PgFormMerge,
    PgFormFilter,
    ClientInput
  },
  data() {
    return {
      // datatable
      headers: [
        { text: "CLIENT", value: "client" },
        { text: "AREA", value: "area" },
        { text: "KAB/KOTA", value: "kab_kota" },
        { text: "TGL. GABUNG", value: "tgl_gabung", align: "center" },
        { text: "JML. KARYAWAN", value: "jml_karyawan", align: "center" },
        { text: "TARGET/THN", value: "target_per_tahun", align: "center" },
        { text: "TOTAL TRAINING", value: "total_training", align: "center" }
      ],
      pagination: {
        sortBy: "tgl_gabung",
        descending: true
      },
      pages: [7, 10, 25, { text: "Semua", value: -1 }],
      selected: [],
      search: "",
      // unique
      title: "CLIENT",
      primary_field: "client",
      primary_key: "id_client",
      // input
      inputDialog: false,
      inputAction: "ADD",
      // delete
      deleteDialog: false,
      // merge
      mergeDialog: false,
      // filter
      filterDialog: false,
      filterDialogTglGabungAwal: false,
      filterDialogTglGabungAkhir: false,
      filterHelperSourceUpdated: false,
      filterSource: [],
      filterOn: false,
      filter: _.cloneDeep(defaultFilter),
      // other
      c: c
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapState("auth", ["profil"]),
    ...mapState("client", ["client_loaded"]),
    ...mapGetters("area", ["areaByLaman"]),
    ...mapGetters("client", ["clientByLaman"]),
    simpleHeaders() {
      return this.headers.filter(h => !["client", "area"].includes(h.value));
    },
    jsonFields() {
      return this.headers.reduce(
        (obj, item) => ((obj[item.text] = item.value), obj),
        {}
      );
    },
    sourceOriginal() {
      /* eslint-disable */
      this.filterHelperSourceUpdated = true;
      return _.cloneDeep(this.$store.getters["client/clientByLamanPeriode"]);
    },
    sourceData() {
      let source = _.cloneDeep(this.sourceOriginal);
      if (
        (this.filterOn && !_.isEqual(source, this.filterSource)) ||
        (this.filterHelperSourceUpdated && this.filterSource.length)
      ) {
        source = this.filterSource;
        /* eslint-disable */
        this.filterHelperSourceUpdated = false;
      }
      return source;
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length == this.sourceData.length) this.selected = [];
      else this.selected = _.cloneDeep(this.sourceData);
    },
    toggleExpand(props) {
      if (this.$vuetify.breakpoint.smAndDown) {
        if (!props.selected) props.expanded = !props.expanded;
        else props.expanded = false;
      } else props.expanded = false;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    openInputDialog(action) {
      this.inputAction = action;
      this.inputDialog = true;
    },
    onSubmitted(new_id) {
      this.inputDialog = false;
      if (!this.$route.query.id) {
        if (this.inputAction == "UPDATE") {
          setTimeout(() => {
            this.selected = [];
          }, 1000);
        }
      } else {
        if (this.inputAction == "ADD") {
          this.$router.push({
            name: this.$route.name,
            query: { id: new_id }
          });
        }
      }
    },
    onDeleted(selected) {
      this.selected = selected;
      // if all success, then close dialog
      if (!this.selected.length) {
        this.deleteDialog = false;
      }
    },
    onMerged(delay) {
      this.mergeDialog = false;
      setTimeout(() => {
        this.selected = [];
      }, delay);
    }
  },
  watch: {
    id_laman$() {
      this.selected = [];
      this.pagination.page = 1;
    }
  },
  mounted() {}
};
</script>
